import { render, staticRenderFns } from "./PublicationList.vue?vue&type=template&id=60f3bdd8&scoped=true"
import script from "./PublicationList.vue?vue&type=script&lang=js"
export * from "./PublicationList.vue?vue&type=script&lang=js"
import style0 from "./PublicationList.vue?vue&type=style&index=0&id=60f3bdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3bdd8",
  null
  
)

export default component.exports